import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { apiError } from "../lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      nav("/");
    } catch (err: any) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-green p-4">
      <div className="nx-fade-up w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center gap-3">
          <svg width="56" height="56" viewBox="0 0 100 100">
            <line x1="72" y1="22" x2="28" y2="78" stroke="#bcd2b2" strokeWidth="2.2" />
            <line x1="28" y1="22" x2="28" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <line x1="72" y1="22" x2="72" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <line x1="28" y1="22" x2="72" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <circle cx="50" cy="50" r="9.7" fill="#AADB4C" />
            <circle cx="50" cy="50" r="3.3" fill="#00524A" />
          </svg>
          <h1 className="text-2xl font-extrabold tracking-wide text-white">NAXIUM ERP</h1>
        </div>
        <form onSubmit={submit} className="nx-card space-y-4 p-6">
          <div>
            <label className="nx-label">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="nx-input"
              placeholder="vous@naxium.net"
            />
          </div>
          <div>
            <label className="nx-label">Mot de passe</label>
            <input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="nx-input"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-danger">
              {error}
            </p>
          )}
          <button data-testid="login-submit-btn" disabled={busy} className="nx-btn-primary w-full justify-center">
            {busy ? "Connexion…" : "Se connecter"}
          </button>
          <Link data-testid="login-forgot-link" to="/forgot" className="block text-center text-sm text-green underline-offset-2 hover:underline">
            Mot de passe oublié ?
          </Link>
        </form>
      </div>
    </div>
  );
}
